export default __webpack_public_path__ + "static/media/harold-veilleux.f6a09785.jpg";